import axios from 'axios';

const API_BASE_URL = 'https://taxntip-backend--taxntip.us-central1.hosted.app';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      console.log('Token expired or invalid, redirecting to login');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Use replace to avoid back button issues
      window.location.replace('/login');
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  signup: (userData) => api.post('/auth/signup', userData),
  signin: (credentials) => api.post('/auth/signin', credentials),
  validateToken: () => api.get('/auth/validate'),
};

// Admin Auth API
export const adminAuthAPI = {
  signup: (adminData) => api.post('/admin/signup', adminData),
  signin: (credentials) => api.post('/admin/signin', credentials),
  validateToken: () => api.get('/admin/validate'),
};

// File Upload API
export const uploadAPI = {
  uploadFile: (file, folderName) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folderName', folderName);

    return api.post('/upload/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getFiles: (folderName) => api.get(`/upload/files?folderName=${folderName}`),
  deleteFile: (s3Key) => api.post('/upload/delete', { s3Key }),
  addFileInfo: (fileData) => api.post('/upload/addFileInfo', fileData),
  getUserFiles: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) queryParams.append(key, params[key]);
    });
    return api.get(`/upload/userFiles?${queryParams}`);
  },
  updateFileInfo: (fileId, fileData) => api.put(`/upload/updateFileInfo/${fileId}`, fileData),
  deleteFileInfo: (fileId) => api.delete(`/upload/deleteFileInfo/${fileId}`),
};

// Admin File Management API
export const adminFileAPI = {
  getAllSubmittedFiles: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) queryParams.append(key, params[key]);
    });
    return api.get(`/admin/files/getAllSubmittedFiles?${queryParams}`);
  },

  getOneSubmittedFile: (fileId) => api.get(`/admin/files/getOneSubmittedFiles/${fileId}`),
  updateFileStatus: (fileData) => api.post('/admin/files/updateSubmittedFile', fileData),
  addAdminResponse: (formData) => api.post('/admin/files/addAdminResponse', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
};

// Admin Users API
export const adminUsersAPI = {
  getUsers: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    return api.get(`/admin/users?${queryParams.toString()}`);
  },
};

// Admin Contact Inquiries API
export const adminContactAPI = {
  list: (params = {}) => {
    const query = new URLSearchParams();
    Object.keys(params).forEach((k) => {
      if (params[k] !== undefined && params[k] !== null && params[k] !== '') query.append(k, params[k]);
    });
    const qs = query.toString();
    return api.get(`/admin/contactus${qs ? `?${qs}` : ''}`);
  },
  getOne: (id) => api.get(`/admin/contactus/${id}`),
  delete: (id) => api.delete(`/admin/contactus/${id}`),
};

export default api;
